// src/services/AboutAndSustainabilityContentService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {

  FAQ_PAGE_CONTENT_DETAIL,
  FAQ_PAGE_UPDATE,
  CONTACT_US_CONTENT_DETAIL,
  CONTACT_US_UPDATE
} from "../../config/constants"; // Adjust endpoints as per your config

const ContactUsContentService = createApi({
  reducerPath: "ContactUsContentService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["ContactUsContent"],
  endpoints: (builder) => ({
    getContactUsContentDetails: builder.query({
      query: (bodyData) => ({
        url: CONTACT_US_CONTENT_DETAIL, // Endpoint to fetch settings list
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["ContactUsContent"],
    }),
    updateContactUsContent: builder.mutation({
      query: ({ updatedData }) => ({
        url: `${CONTACT_US_UPDATE}`, // Endpoint to update a settings
        method: "PUT",
        data: updatedData, // Updated settings data
      }),
      invalidatesTags: ["ContactUsContent"],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetContactUsContentDetailsQuery,
  useUpdateContactUsContentMutation,
} = ContactUsContentService;

// Export the reducer to be included in the store
export default ContactUsContentService;
